import { Box } from '@mui/material';
import React from 'react';
import { getProjectTypeSelectOptionsAssumption } from './utils';

export function assumptionEditorColumn(AllLists: any, getCommonEditTextFieldProps: any) {
    return [{
        accessorKey: "RawProjectType",
        header: "Project type",
        size: 200,
        filterVariant: "multi-select",
        editVariant: "select",
        editSelectOptions: getProjectTypeSelectOptionsAssumption(AllLists),
    },
    {
        id: "TimeAllocation",
        header: "Time Allocation", columns: [
            {
                id: "PlanningTimePercentage",
                accessorFn: (row) => parseInt(row.PlanningTimePercentage),
                filterFn: "betweenInclusive",
                filterVariant: "range",
                header: "Planning",
                size: 100,
                Cell: ({ cell }) => {
                    return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        {
                            // @ts-ignore
                            cell.getValue<number>().toLocaleString() + " %"
                        }
                    </Box>;
                },
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell)
                }),
            }, {
                id: "ConstructionTimePercentage",
                accessorFn: (row) => parseInt(row.ConstructionTimePercentage),
                filterFn: "betweenInclusive",
                filterVariant: "range",
                header: "Construction",
                size: 120,
                Cell: ({ cell }) => {
                    return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        {
                            // @ts-ignore
                            cell.getValue<number>().toLocaleString() + " %"
                        }
                    </Box>;
                },
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell)
                }),
            }, {
                id: "CommissioningTimePercentage",
                accessorFn: (row) => parseInt(row.CommissioningTimePercentage),
                filterFn: "betweenInclusive",
                filterVariant: "range",
                header: "Commission",
                size: 120,
                Cell: ({ cell }) => {
                    return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        {
                            // @ts-ignore
                            cell.getValue<number>().toLocaleString() + " %"
                        }
                    </Box>;
                },
                muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                    ...getCommonEditTextFieldProps(cell)
                }),
            }, {
                id: "TimeTotal",
                filterFn: "betweenInclusive",
                filterVariant: "range",
                header: "Total",
                size: 100,
                enableEditing: false,
                Cell: ({ row, table }) => {
                    const editingRow = table.getState().editingRow;
                    const editingRowIndex = editingRow?.index
                    const valuesCache = row.index === editingRowIndex ? editingRow._valuesCache : row._valuesCache;
                    const totalTime = parseInt(valuesCache["PlanningTimePercentage"]) + parseInt(valuesCache["ConstructionTimePercentage"]) + parseInt(valuesCache["CommissioningTimePercentage"]);
                    const totalColor = totalTime === 100 ? "" : "error.main";
                    return (
                        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", color: totalColor }}>
                            {totalTime} %
                        </Box>
                    );
                },
            }]
    },
    {
        id: "CostAllocation", header: "Investment Allocation", columns: [{
            id: "PlanningCostPercentage",
            accessorFn: (row) => parseInt(row.PlanningCostPercentage),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Planning",
            size: 100,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString() + " %"
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        }, {
            id: "ConstructionCostPercentage",
            accessorFn: (row) => parseInt(row.ConstructionCostPercentage),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Construction",
            size: 120,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString() + " %"
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        }, {
            id: "CommissioningCostPercentage",
            accessorFn: (row) => parseInt(row.CommissioningCostPercentage),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Commission",
            size: 120,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString() + " %"
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        }, {
            id: "CostTotal",
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Total",
            size: 100,
            enableEditing: false,
            Cell: ({ row, table }) => {
                const editingRow = table.getState().editingRow;
                const editingRowIndex = editingRow?.index
                const valuesCache = row.index === editingRowIndex ? editingRow._valuesCache : row._valuesCache;
                const totalTime = parseInt(valuesCache["PlanningCostPercentage"]) + parseInt(valuesCache["ConstructionCostPercentage"]) + parseInt(valuesCache["CommissioningCostPercentage"]);
                const totalColor = totalTime === 100 ? "" : "error.main";
                return (
                    <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", color: totalColor }}>
                        {totalTime} %
                    </Box>
                );

            }
        }]
    }
    ]
}